export default "__VITE_ASSET__CHj5a0Kf__"